<template>
  <div class="p-4 sm:p-6 lg:p-8">
    <!-- Page Header -->
    <!-- <div class="max-w-7xl mx-auto mb-8">
      <h1 class="text-3xl sm:text-4xl font-bold text-gray-900 dark:text-white mb-2">
        What is Total Confidence Plan?
      </h1>
      <p class="text-base sm:text-lg text-gray-600 dark:text-gray-400">
        Learn about our comprehensive tire protection program
      </p>
    </div> -->

    <!-- Main TCP Definition Card -->
    <div class="max-w-7xl mx-auto mb-4 sm:mb-6">
      <div
        class="overflow-hidden"
      >
      <!-- <div
        class="bg-white dark:bg-black rounded-xl shadow-lg overflow-hidden border-2 transition-all duration-300 hover:shadow-xl hover:-translate-y-1"
        :style="{ borderColor: 'var(--brand-primary)' }"
      > -->
        <div class="p-6 sm:p-8 lg:p-10">
          <div class="flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6 mb-6">
            <!-- Icon -->
            <div
              class="flex-shrink-0  sm:w-20 sm:h-20 md:w-[210px] rounded-2xl flex items-center justify-center"
              :style="{ backgroundColor: 'var(--brand-primary)' + '20' }"
            >
              <!-- <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-8 w-8 sm:h-10 sm:w-10"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                :style="{ color: 'var(--brand-primary)' }"
              >
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg> -->
              <img
                v-if="isFalken"
                src="@/assets/falken-page-logo.png"
                alt="Logo"
                class="w-full sm:w-[150px] max-w-[300px] md:w-[200px] lg:w-[300px] p-2 md:mr-9"
              />
              <img
                v-else
                src="@/assets/tcp-page-logo.png"
                alt="Logo"
                class="w-full p-2"
              />
            </div>

            <!-- Title -->
            <div class="flex-1">
              <h2 class="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white mb-3">
                {{ isFalken ? 'What is Road Hazard Ready (RHR)?' : 'What is Total Confidence Plan (TCP)?' }}
              </h2>
              <p v-if="isFalken" class="text-base sm:text-lg text-gray-700 dark:text-gray-300 leading-relaxed">
                Road Hazard Ready (RHR) provides eligible retail customers of selected Falken tires with enhanced warranty coverage for 12 months from the date of purchase againts qualified road-hazard damages. This includes a one-to-one tire replacement at no extra cost to the customer.
              </p>
              <p v-else class="text-base sm:text-lg text-gray-700 dark:text-gray-300 leading-relaxed">
                Total Confidence Plan (TCP) provides eligible retail customers of Continental tires with enhanced warranty coverage for 12 months from the date of purchase against qualified road-hazard damages. This includes a one-to-one tire replacement at no extra cost to the customer.
              </p>
              <!-- <p class="text-sm sm:text-base text-gray-600 dark:text-gray-400 mt-3 italic">
                *Only Continental PLT tires purchased from JMFEI are covered. OE fitted tires are not included.
              </p> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Three Info Cards -->
    <div class="max-w-7xl mx-auto mb-4 sm:mb-6">
      <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">

        <!-- Criteria Card -->
        <div class="bg-gray-50 dark:bg-black rounded-xl shadow-md overflow-hidden border border-gray-200 dark:border-gray-700 transition-all duration-300 hover:shadow-xl hover:-translate-y-1">
          <div class="p-6">
            <!-- Icon -->
            <div
              class="rounded-xl flex items-center justify-center mb-4"
            >
              <img
                v-if="isFalken"
                src="@/assets/Eligibility-falken.png"
                alt="Logo"
                class="w-16 p-2"
              />
              <img
                v-else
                src="@/assets/Eligibility.png"
                alt="Logo"
                class="w-16 p-2"
              />
              <!-- Title -->
              <h3 class="text-xl font-bold text-gray-900 dark:text-white">
                ELIGIBILITY
              </h3>
            </div>

            

            <!-- Content -->
            <ul class="space-y-3">
              <li class="flex items-start">
                <!-- <svg class="h-5 w-5 text-green-500 dark:text-green-400 mr-3 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                </svg> -->
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-check-big-icon lucide-circle-check-big text-green-500 dark:text-green-400 mr-3 mt-0.5 flex-shrink-0"><path d="M21.801 10A10 10 0 1 1 17 3.335"/><path d="m9 11 3 3L22 4"/></svg>
                <span class="text-sm text-gray-700 dark:text-gray-300">
                  {{ isFalken ? 'Selected Falken passenger and light truck (PLT) tires only. Azenis RT660, RT615K+ and Commercial tires are NOT included.' : 'Continental Passenger, SUV/4X4, and Van/Light Truck tires (PLT). Commercial tires are NOT included.' }}
                </span>
              </li>
              <li class="flex items-start">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-check-big-icon lucide-circle-check-big text-green-500 dark:text-green-400 mr-3 mt-0.5 flex-shrink-0"><path d="M21.801 10A10 10 0 1 1 17 3.335"/><path d="m9 11 3 3L22 4"/></svg>
                <span class="text-sm text-gray-700 dark:text-gray-300">
                  Requires the purchase of at least two (2) PLT tires in one (1) single transaction.
                </span>
              </li>
              <li class="flex items-start">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-check-big-icon lucide-circle-check-big text-green-500 dark:text-green-400 mr-3 mt-0.5 flex-shrink-0"><path d="M21.801 10A10 10 0 1 1 17 3.335"/><path d="m9 11 3 3L22 4"/></svg>
                <span class="text-sm text-gray-700 dark:text-gray-300">
                  Customer must register their tires within seven (7) days from date of purchase.
                </span>
              </li>
              
            </ul>
          </div>
        </div>

        <!-- Warranty Card -->
        <div class="bg-gray-50 dark:bg-black rounded-xl shadow-md overflow-hidden border border-gray-200 dark:border-gray-700 transition-all duration-300 hover:shadow-xl hover:-translate-y-1">
          <div class="p-6">
            <!-- Icon -->
            <div
              class="rounded-xl flex items-center justify-center mb-4"
              :style="{ backgroundColor: 'var(--brand-primary)' + '20' }"
            >
              <img
                v-if="isFalken"
                src="@/assets/Warranty-falken.png"
                alt="Logo"
                class="w-16 p-2"
              />
              <img
                v-else
                src="@/assets/Warranty.png"
                alt="Logo"
                class="w-16 p-2"
              />
              <!-- Title -->
              <h3 class="text-xl font-bold text-gray-900 dark:text-white">
                WARRANTY
              </h3>
            </div>

            

            <!-- Content -->
            <ul class="space-y-3">
              <li class="flex items-start">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-check-big-icon lucide-circle-check-big text-green-500 dark:text-green-400 mr-3 mt-0.5 flex-shrink-0"><path d="M21.801 10A10 10 0 1 1 17 3.335"/><path d="m9 11 3 3L22 4"/></svg>
                <span class="text-sm text-gray-700 dark:text-gray-300">
                  First 12 months upon purchase (based on the date indicated on the official receipt).
                </span>
              </li>
              <li class="flex items-start">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-check-big-icon lucide-circle-check-big text-green-500 dark:text-green-400 mr-3 mt-0.5 flex-shrink-0"><path d="M21.801 10A10 10 0 1 1 17 3.335"/><path d="m9 11 3 3L22 4"/></svg>
                <span class="text-sm text-gray-700 dark:text-gray-300">
                  If unrepairable tire damage, 1-to-1 replacement (if RTD* ≥ 5mm) - applicable only to all unrepairable damage.
                </span>
              </li>
              <li class="flex items-start">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-check-big-icon lucide-circle-check-big text-green-500 dark:text-green-400 mr-3 mt-0.5 flex-shrink-0"><path d="M21.801 10A10 10 0 1 1 17 3.335"/><path d="m9 11 3 3L22 4"/></svg>
                <span class="text-sm text-gray-700 dark:text-gray-300">
                  All service charges during claim procedure (mounting / balancing /alignment) to be borne by consumer.
                </span>
              </li>
              <li class="flex items-start">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-check-big-icon lucide-circle-check-big text-green-500 dark:text-green-400 mr-3 mt-0.5 flex-shrink-0 invisible"><path d="M21.801 10A10 10 0 1 1 17 3.335"/><path d="m9 11 3 3L22 4"/></svg>
                <span class="text-sm text-gray-700 dark:text-gray-300">
                  *RTD = remaining tread depth
                </span>
              </li>
            </ul>
          </div>
        </div>

        <!-- Coverage Card -->
        <div class="bg-gray-50 dark:bg-black rounded-xl shadow-md overflow-hidden border border-gray-200 dark:border-gray-700 transition-all duration-300 hover:shadow-xl hover:-translate-y-1">
          <div class="p-6">
            <!-- Icon -->
            <div
              class="rounded-xl flex items-center justify-center mb-4"
              :style="{ backgroundColor: 'var(--brand-primary)' + '20' }"
            >
              <img
                v-if="isFalken"
                src="@/assets/Coverage-falken.png"
                alt="Logo"
                class="w-16 p-2"
              />
              <img
                v-else
                src="@/assets/Coverage.png"
                alt="Logo"
                class="w-16 p-2"
              />
              <!-- Title -->
              <h3 class="text-xl font-bold text-gray-900 dark:text-white">
                COVERAGE
              </h3>
            </div>

            <!-- Content -->
            <ul class="space-y-3">
              <li class="flex items-start">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-check-big-icon lucide-circle-check-big text-green-500 dark:text-green-400 mr-3 mt-0.5 flex-shrink-0"><path d="M21.801 10A10 10 0 1 1 17 3.335"/><path d="m9 11 3 3L22 4"/></svg>
                <span class="text-sm text-gray-700 dark:text-gray-300">
                  Tires must be purchased from any JMFEI authorized dealers or sub-dealers.
                </span>
              </li>
              <li class="flex items-start">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-check-big-icon lucide-circle-check-big text-green-500 dark:text-green-400 mr-3 mt-0.5 flex-shrink-0"><path d="M21.801 10A10 10 0 1 1 17 3.335"/><path d="m9 11 3 3L22 4"/></svg>
                <span class="text-sm text-gray-700 dark:text-gray-300">
                  {{ isFalken ? 'Purchases from the official online stores of Falken Tire Philippines are also included.' : 'Purchases from the official online stores of Continental Tire Philippines are also included.' }}
                </span>
              </li>
              <li class="flex items-start">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-check-big-icon lucide-circle-check-big text-green-500 dark:text-green-400 mr-3 mt-0.5 flex-shrink-0"><path d="M21.801 10A10 10 0 1 1 17 3.335"/><path d="m9 11 3 3L22 4"/></svg>
                <span class="text-sm text-gray-700 dark:text-gray-300">
                  {{ isFalken ? 'PLT tires up to six (6) years old from current calendar year are eligible for this program.' : 'Only Continental Passenger, SUV/4X4, and Van/Light Truck (PLT) tires with a date of manufacture within nine (9) years from the current calendar year are eligible for this Program.' }}
                </span>
              </li>
              <li class="flex items-start">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-check-big-icon lucide-circle-check-big text-green-500 dark:text-green-400 mr-3 mt-0.5 flex-shrink-0"><path d="M21.801 10A10 10 0 1 1 17 3.335"/><path d="m9 11 3 3L22 4"/></svg>
                <span class="text-sm text-gray-700 dark:text-gray-300">
                  OE fitted tires are not included.
                </span>
              </li>
            </ul>
          </div>
        </div>

      </div>
    </div>

    <div class="max-w-7xl mx-auto mb-4 sm:mb-6">
      <section class="max-w-6xl mx-auto px-6 py-16 text-center">
        
        <!-- Heading -->
        <h2 class="text-3xl md:text-4xl font-bold mb-3" :style="{ color: 'var(--brand-primary)' }">
          Give your tires the protection they deserve
        </h2>
        <p class="text-gray-700 dark:text-white text-lg mb-12">
          4 Easy Steps to Enjoy Added Confidence
        </p>

        <!-- Steps -->
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 place-items-center">

          <!-- Step 1 -->
          <div class="relative w-64 h-64 rounded-full bg-black text-white flex items-center justify-center text-center p-6 shadow-lg">
            <div class="absolute inset-0 rounded-full border-4" :style="{ borderColor: 'var(--brand-primary)' }"></div>
            <div class="relative">
              <p class="font-semibold tracking-wide mb-3">STEP 01</p>
              <p class="text-sm leading-relaxed">
                Buy a min. of two (2) pcs. of {{ isFalken ? 'participating Falken' : 'Continental' }} PLT tires at any authorized dealer.
              </p>
            </div>
          </div>

          <!-- Step 2 -->
          <div class="relative w-64 h-64 rounded-full bg-black text-white flex items-center justify-center text-center p-6 shadow-lg">
            <div class="absolute inset-0 rounded-full border-4" :style="{ borderColor: 'var(--brand-primary)' }"></div>
            <div class="relative">
              <p class="font-semibold tracking-wide mb-3">STEP 02</p>
              <p class="text-sm leading-relaxed">
                Create your {{ isFalken ? 'Falken' : 'Continental' }} account and register your personal details.
              </p>
            </div>
          </div>

          <!-- Step 3 -->
          <div class="relative w-64 h-64 rounded-full bg-black text-white flex items-center justify-center text-center p-6 shadow-lg">
            <div class="absolute inset-0 rounded-full border-4" :style="{ borderColor: 'var(--brand-primary)' }"></div>
            <div class="relative">
              <p class="font-semibold tracking-wide mb-3">STEP 03</p>
              <p class="text-sm leading-relaxed">
                Register your vehicle and your tires within seven (7) days from purchase date.
              </p>
            </div>
          </div>

          <!-- Step 4 -->
          <div class="relative w-64 h-64 rounded-full bg-black text-white flex items-center justify-center text-center p-6 shadow-lg">
            <div class="absolute inset-0 rounded-full border-4" :style="{ borderColor: 'var(--brand-primary)' }"></div>
            <div class="relative">
              <p class="font-semibold tracking-wide mb-3">STEP 04</p>
              <p class="text-sm leading-relaxed">
                Receive a confirmation of your tire registration.
              </p>
              <p class="text-xs text-gray-300 mt-3">
                All registrations are subject for approval.
              </p>
            </div>
          </div>

        </div>

        <!-- Participating Patterns (Falken Only) -->
        <div v-if="isFalken" class="mt-20">
          <h3 class="text-2xl font-semibold mb-12 text-center text-blue-600 dark:text-blue-400">Participating Patterns</h3>
          
          <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-8 text-sm text-center">
            <!-- SINCERA -->
            <div class="flex flex-col items-center">
              <h4 class="font-black text-4xl italic tracking-wider mb-4 uppercase text-black dark:text-white">Sincera</h4>
              <ul class="space-y-1 text-blue-600 dark:text-blue-400 font-medium text-center text-base">
                <li>Sincera SN832i</li>
              </ul>
            </div>

            <!-- ZIEX -->
            <div class="flex flex-col items-center">
              <h4 class="font-black text-4xl italic tracking-wider mb-4 uppercase text-black dark:text-white">Ziex</h4>
              <ul class="space-y-1 text-blue-600 dark:text-blue-400 font-medium text-center text-base">
                <li>Ziex ZE310</li>
                <li>Ziex STZ05</li>
              </ul>
            </div>

            <!-- AZENIS -->
            <div class="flex flex-col items-center">
              <h4 class="font-black text-4xl italic tracking-wider mb-4 uppercase text-black dark:text-white">Azenis</h4>
              <ul class="space-y-1 text-blue-600 dark:text-blue-400 font-medium mb-4 text-center text-base">
                <li>Azenis FK510</li>
                <li>Azenis FK510 SUV</li>
                <li>Azenis FK520L</li>
              </ul>
              <div class="text-center">
                <span class="text-red-500 font-bold uppercase block mb-1 underline">NOT INCLUDED:</span>
                <ul class="space-y-1 text-blue-600 dark:text-blue-400 font-medium text-base">
                  <li>Azenis RT660</li>
                  <li>Azenis RT615K+</li>
                </ul>
              </div>
            </div>

            <!-- WILDPEAK -->
            <div class="flex flex-col items-center">
              <h4 class="font-black text-4xl italic tracking-wider mb-4 uppercase text-black dark:text-white">Wildpeak</h4>
              <ul class="space-y-1 text-blue-600 dark:text-blue-400 font-medium text-center text-base">
                <li>Wildpeak A/T Trail</li>
                <li>Wildpeak HT01</li>
                <li>Wildpeak AT3W</li>
                <li>Wildpeak AT4W</li>
                <li>Wildpeak RT01</li>
                <li>Wildpeak MT01</li>
              </ul>
            </div>

            <!-- LINAM -->
            <div class="flex flex-col items-center">
              <h4 class="font-black text-4xl italic tracking-wider mb-4 uppercase text-black dark:text-white">Linam</h4>
              <ul class="space-y-1 text-blue-600 dark:text-blue-400 font-medium text-center text-base">
                <li>Linam Van01</li>
              </ul>
            </div>
          </div>
        </div>

        <!-- Footer Links -->
        <div class="mt-14 text-gray-700 dark:text-white text-lg">
          Got questions? Click here:
          <a href="#" class="font-semibold hover:underline" :style="{ color: 'var(--brand-primary)' }">
            Mechanics
          </a>
          and
          <a href="#" class="font-semibold hover:underline" :style="{ color: 'var(--brand-primary)' }">
            Terms & Conditions
          </a>
        </div>

      </section>
    </div>

  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useTitle } from '@/composables/ui/useTitle'
import { useBrand } from '@/composables/brand/useBrand'

const { currentBrand } = useBrand()
const isFalken = computed(() => currentBrand.value?.name?.toLowerCase() === 'falken')

const appTitle = computed(() => process.env.VUE_APP_TITLE || 'SP Team Template')

useTitle(`${appTitle.value} - ${isFalken.value ? 'What is RHR?' : 'What is TCP?'}`)
</script>